import { sendMessageRoundTripTime } from 'api/messages'
import { Message } from 'types/message'
import { error, log, warn } from 'utils'

interface SendMessageRoundTripPayload {
  message: Partial<Message>,
  timedOut: boolean
}

export const sendMessageRoundTripMetric = ({ message, timedOut = false }: SendMessageRoundTripPayload) => {
  const { attributes = {} } = message

  if (!attributes.generatedAt) {
    return
  }

  const context = {
    isTimeout: timedOut,
    isFirstMessage: attributes.isFirstMessage,
    widgetGuid: attributes.widgetGuid,
    messageId: message.id,
    conversationId: message.conversationId
  }

  const roundTripTime = Date.now() - attributes.generatedAt
  const messageType = attributes.isFirstMessage ? 'conversationRoundTripTime' : 'messageRoundTripTime'

  if (timedOut) {
    warn([`Round-trip timed out for message ${message.id}`])
  } else {
    log({ data: [`Round-trip time for message ${message.id} completed in ${roundTripTime}`]})
  }

  try {
    sendMessageRoundTripTime({
      name: messageType,
      value: roundTripTime,
      context
    })
  } catch(err) {
    error(err)
  }
}
